__turbopack_context__.v({
  "breadcrumbsWrapper": "BespokePLACondensedLayout-module__1S0Caa__breadcrumbsWrapper",
});
